export default {
  common: {
    account: '계정',
    agents: '에이전트',
    all: '전체',
    available: '사용 가능',
    cancel: '취소',
    cloud: '클라우드',
    copy: '복사',
    current: '현재',
    delete: '삭제',
    error: '오류',
    export: '내보내기',
    help: '도움말',
    home: '홈',
    language: '언어',
    links: '링크',
    loading: '로딩 중',
    local: '로컬',
    login: '로그인',
    logout: '로그아웃',
    metadata: '메타데이터',
    more: '더 보기',
    name: '이름',
    never: '없음',
    none: '없음',
    notes: '노트',
    ok: '확인',
    open: '열기',
    password: '비밀번호',
    project: '프로젝트',
    projects: '프로젝트',
    publicLink: '공개 링크',
    register: '가입',
    remove: '제거',
    save: '저장',
    search: '검색',
    settings: '설정',
    subscribe: '구독',
    track: '트랙',
    tracks: '트랙',
    unknown: '알 수 없음',
    unknownArtist: '알 수 없는 아티스트',
    upload: '업로드',
    username: '사용자 이름'
  },
  time: {
    day: '일',
    days: '일',
    daysAgo: (ctx) => `${ctx.named('count')}일 전`,
    hoursAgo: (ctx) => `${ctx.named('count')}시간 전`,
    minutesAgo: (ctx) => `${ctx.named('count')}분 전`,
    rightNow: '방금',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      if (minutes > 0) return `${minutes}분 ${seconds}초`
      return `${seconds}초`
    }
  },
  topBar: {
    accountFallback: '계정',
    storage: '스토리지',
    language: '언어'
  },
  commandPalette: {
    placeholder: '트랙과 프로젝트 검색...',
    projects: '프로젝트',
    tracks: '트랙',
    pages: '페이지',
    noResults: '결과가 없습니다',
    quickLinks: '빠른 링크',
    page: {
      home: '홈',
      account: '계정',
      agents: '에이전트',
      links: '링크',
      settings: '설정',
      help: '도움말'
    }
  },
  explorer: {
    searchTitle: '검색',
    trackCount: (ctx) => `${ctx.named('count')}개 트랙`
  },
  emptyState: {
    hello: '안녕하세요',
    addTrack: '트랙 추가',
    addTrackSubtitle: '시작하려면',
    dragDrop: '드래그 앤 드롭',
    dragDropSubtitle: '파일을 빠르게 업로드',
    switchStorage: '전환',
    switchStorageSubtitle: '상단 메뉴에서 클라우드와 로컬을 전환',
    installAgent: '에이전트 설치',
    installAgentSubtitle: '파일을 자동으로 업로드',
    playTrack: '트랙 재생',
    playTrackSubtitle: '하단 플레이어를 열어 효과 사용',
    community: '질문이 있나요? {discord} 및 {telegram} 커뮤니티에 참여하세요.'
  },
  create: {
    createProject: '프로젝트 만들기',
    uploadTrack: '트랙 업로드',
    newProject: '새 프로젝트',
    artist: '아티스트',
    name: '이름',
    create: '만들기',
    loading: '로딩 중...',
    uploadCover: '커버 업로드'
  },
  upload: {
    ariaLabel: '트랙 업로드',
    uploadTrack: '트랙 업로드',
    analyzing: '분석 중...',
    fileAdded: '파일 "{name}"이 추가되었습니다',
    fileReadError: '파일 읽기 오류.',
    errorWithMessage: '오류: {message}'
  },
  dragDrop: {
    dropToUpload: '놓으면 업로드',
    deleteDrop: '여기에 놓으면 트랙이 영구 삭제됩니다'
  },
  project: {
    upload: '업로드',
    noTracks: '트랙 없음',
    createdBy: '생성자',
    trackSummary: (ctx) => `${ctx.named('count')}개 트랙, ${ctx.named('duration')}`,
    play: '재생',
    pause: '일시정지'
  },
  trackItem: {
    more: '더 보기',
    copyPublicLink: '공개 링크 복사',
    savedLocally: '로컬에 저장됨',
    saveLocal: '로컬 스토리지에 저장',
    saving: '저장 중...',
    saveCloud: '클라우드에 저장',
    deleteTrack: '트랙 삭제',
    moveUp: '위로 이동',
    moveDown: '아래로 이동',
    removeFromProject: '{project}에서 제거',
    moveToProject: '프로젝트로 이동',
    currentProject: '(현재)',
    confirmDelete: '이 트랙을 삭제하시겠습니까?',
    linkCopiedTitle: '링크 복사됨',
    linkCopiedDescription: '공개 링크가 클립보드에 복사되었습니다'
  },
  trackView: {
    created: '{time} 생성',
    tabs: {
      notes: '노트',
      metadata: '메타데이터'
    },
    notFound: '트랙을 찾을 수 없거나 사용할 수 없습니다',
    untitled: '제목 없음'
  },
  notes: {
    placeholder: '이 트랙에 대한 노트를 추가하세요...',
    saving: '저장 중...',
    saveError: '노트를 저장할 수 없습니다. 다시 시도하세요.'
  },
  metadata: {
    trackOrder: '트랙 순서',
    artist: '아티스트',
    name: '이름',
    key: '키',
    mode: '모드',
    deleteTrack: '트랙 삭제',
    saveError: '메타데이터를 저장할 수 없습니다. 다시 시도하세요.'
  },
  lufs: {
    momentary: '모멘터리 LUFS',
    shortTerm: '단기 LUFS',
    integrated: '통합 LUFS'
  },
  effects: {
    pitchshift: '피치 시프트',
    speed: '속도',
    balance: '밸런스',
    volume: '볼륨',
    reverberation: '리버브',
    distortion: '디스토션',
    bitcrush: '비트크러시',
    saveCurrentEffectsAs: '현재 효과를 다음 이름으로 저장',
    presetName: '이름',
    add: '추가',
    availablePresets: '사용 가능한 프리셋',
    tune: '튠',
    eq: 'EQ',
    fx: 'FX',
    presets: '프리셋',
    center: '가운데',
    left: '왼쪽',
    right: '오른쪽'
  },
  exportPanel: {
    applyEffects: '현재 효과 적용',
    applyEffectsSubtitle: '현재 효과가 적용된 트랙 내보내기',
    exportWav: 'WAV로 내보내기',
    exportMp3: 'MP3로 내보내기',
    exporting: '내보내는 중...',
    exportAsNewTrack: '새 트랙으로 내보내기',
    creatingTrack: '트랙 생성 중...',
    downloadOriginal: '원본 다운로드',
    originalUnavailable: '원본 파일을 사용할 수 없습니다.',
    downloadOriginalFailed: '원본 파일을 다운로드할 수 없습니다.',
    exportAudioFailed: '트랙 오디오를 내보낼 수 없습니다.',
    waveformFailed: '웨이브폼을 생성할 수 없습니다.',
    createTrackFailed: '내보낸 트랙을 생성할 수 없습니다.',
    createTrackAlert: '내보낸 트랙을 생성할 수 없습니다: {message}',
    exportedSuffix: ' (내보내기)',
    copySuffix: ' (복사본)'
  },
  publicLink: {
    copy: '복사',
    open: '열기',
    linkCopiedTitle: '링크 복사됨',
    linkCopiedDescription: '공개 링크가 클립보드에 복사되었습니다'
  },
  settings: {
    tabs: {
      settings: '설정',
      account: '계정',
      links: '링크',
      agents: '에이전트'
    },
    display: '표시',
    language: '언어',
    showBpm: '트랙 보기에서 BPM 표시',
    showBpmSubtitle: '트랙 목록에서 각 트랙의 BPM을 표시',
    showLufs: '트랙 보기에서 LUFS 표시',
    showLufsSubtitle: '트랙 목록에서 각 트랙의 라우드니스 단위를 표시',
    showKey: '트랙 보기에서 키 표시',
    showKeySubtitle: '트랙 목록에서 각 트랙의 키와 모드를 표시',
    playback: '재생',
    liveLoudness: '실시간 라우드니스 미터',
    liveLoudnessSubtitle: '플레이어 화면에 실시간 라우드니스 미터 표시',
    persistEffects: '모든 트랙에 적용 효과 유지',
    persistEffectsSubtitle: '트랙이 변경되어도 적용된 효과를 유지',
    keyboardShortcuts: '키보드 단축키',
    search: '검색',
    pressShortcut: '원하는 키 조합을 누르세요',
    storage: '스토리지',
    resetPresetsInfo: '이 브라우저에 저장된 모든 프리셋 초기화',
    resetPresets: '프리셋 초기화',
    resetAllWarning: '경고! 아래 버튼은 로컬 스토리지의 모든 데이터를 삭제합니다.',
    resetAllData: '로컬 스토리지를 초기화하고 모든 트랙과 프로젝트 삭제',
    loadingAccount: '계정 로딩 중...',
    loadingLinks: '링크 로딩 중...',
    loadingAgents: '에이전트 로딩 중...',
    authPrompt: '이 섹션을 사용하려면 로그인하거나 가입하세요.',
    loginRegister: '로그인 또는 가입',
    pageTitle: {
      settings: '설정',
      account: '계정 설정',
      links: '공개 링크',
      agents: '에이전트'
    },
    presetsCleared: '프리셋 저장소가 지워졌습니다',
    localDataDeleted: '모든 로컬 데이터가 삭제되었습니다',
    linkCopied: '링크 복사됨',
    linkCopyFailed: '링크를 복사할 수 없습니다'
  },
  account: {
    hello: '안녕하세요, {name}.',
    subscriptionStatus: '현재 구독 상태는 {status}입니다',
    noSubscription: '활성 구독이 없습니다.',
    manageSubscription: '구독 및 결제 수단 관리',
    subscribeCloud: '클라우드 사용을 위해 구독',
    changeUsername: '사용자 이름 변경',
    changePassword: '비밀번호 변경',
    saveUsername: '사용자 이름 저장',
    savePassword: '비밀번호 저장',
    newPassword: '새 비밀번호',
    confirmPassword: '비밀번호 확인',
    usernamePlaceholder: '사용자 이름',
    storageUsage: '스토리지 사용량',
    baseStorage: '기본 스토리지',
    subscriptionStorage: '구독 스토리지',
    used: '사용됨',
    available: '사용 가능',
    deletedFilesNotice: '최근 삭제한 파일은 아직 이 지표에 포함될 수 있습니다. 몇 시간 내에 갱신됩니다.',
    accountId: '계정 id',
    currentPeriodEnds: (ctx) => `현재 결제 기간은 ${ctx.named('count')} ${ctx.named('label')} 후 종료됩니다`,
    accessEnds: (ctx) => `구독 접근 권한은 ${ctx.named('count')} ${ctx.named('label')} 후 종료됩니다`,
    lastPaymentEnded: (ctx) => `마지막 결제 기간은 ${ctx.named('date')}에 종료되었습니다`,
    previousBillingDate: '이전 결제일',
    billingPortalError: '결제 포털 오류',
    billingPortalFailed: '결제 포털을 열 수 없습니다.',
    loginRequiredUpdate: '프로필을 업데이트하려면 로그인해야 합니다.',
    usernameEmpty: '사용자 이름은 비워둘 수 없습니다.',
    usernameUnchanged: '사용자 이름이 변경되지 않았습니다.',
    usernameUpdated: '사용자 이름이 업데이트되었습니다',
    usernameUpdateFailed: '사용자 이름을 업데이트할 수 없습니다. 다시 시도하세요.',
    passwordEmpty: '비밀번호는 비워둘 수 없습니다.',
    passwordsMismatch: '비밀번호가 일치하지 않습니다.',
    passwordUpdated: '비밀번호가 업데이트되었습니다',
    passwordUpdateFailed: '비밀번호를 업데이트할 수 없습니다. 다시 시도하세요.'
  },
  links: {
    title: '공개 링크',
    description: '모든 공개 링크가 여기에 표시됩니다. 접근 권한이 있는 누구나 프로젝트나 트랙을 들을 수 있습니다.',
    cloudOnly: '공개 링크는 클라우드 모드에서만 사용할 수 있습니다. 공개 링크를 만들고 관리하려면 클라우드 스토리지로 전환하세요.',
    noLinks: '사용 가능한 공개 링크가 없습니다',
    createFirst: '공유를 시작하려면 첫 공개 링크를 만드세요.',
    confirmDelete: '이 링크를 삭제하시겠습니까?',
    notFoundTitle: '링크를 찾을 수 없거나 만료됨',
    notFoundDescription: '접근하려는 링크가 유효하지 않거나 만료되었습니다.',
    unknownUser: '알 수 없음'
  },
  agents: {
    authorizeTitle: '에이전트 승인',
    authorizeDescription: '이 에이전트가 계정에 연결하도록 허용합니다.',
    loginToAuthorize: '이 에이전트를 승인하려면 로그인하세요.',
    wantsConnect: '이 에이전트는 오디오 파일을 자동으로 업로드하기 위해 계정에 연결하려고 합니다.',
    permissionUpload: '트랙 업로드',
    permissionMetadata: '트랙 메타데이터 생성',
    authorize: '승인',
    cancel: '취소',
    authorizedTitle: '에이전트 승인됨',
    authorizedDescription: '이제 이 창을 닫고 에이전트 앱으로 돌아갈 수 있습니다.',
    desktopTitle: '데스크톱 에이전트',
    installDescription: 'PC 또는 Mac에 demoparty 에이전트를 설치하면 새로 렌더링한 트랙을 자동 업로드할 수 있습니다.',
    warningLabel: '경고: ',
    alphaWarning: '에이전트는 alpha 상태이며 불안정할 수 있습니다.',
    downloadMacApple: 'Apple Silicon Mac용 다운로드',
    downloadMacIntel: 'Intel Mac용 다운로드',
    downloadWindows: 'Windows x64용 다운로드',
    signingNotice: '프로젝트가 아직 개발 중이므로 이 빌드는 디지털 서명되지 않았습니다. 실행 시 보안 경고가 표시될 수 있습니다. 서명된 빌드는 나중에 제공됩니다.',
    activeTitle: '활성 에이전트',
    connectedDescription: '계정에 연결된 에이전트.',
    loginToManage: '에이전트를 관리하려면 로그인하세요.',
    noAgents: '아직 연결된 에이전트가 없습니다.',
    lastUsed: '마지막 사용',
    revoke: '철회',
    remove: '제거',
    confirmRemove: '이 에이전트를 제거하시겠습니까?',
    authorizeFailed: '에이전트를 승인할 수 없습니다. 다시 시도하세요.'
  },
  login: {
    intro: '클라우드 기능과 구독 혜택을 사용하려면 로그인해야 합니다. 그렇지 않으면 서비스를 로컬에서 무료로 사용할 수 있습니다.',
    subscriptionBenefits: '구독 혜택',
    login: '로그인',
    register: '가입',
    forgot: '비밀번호를 잊었습니다',
    email: 'e-mail',
    password: '비밀번호',
    repeatPassword: '비밀번호 반복',
    or: '또는',
    google: 'Google로 로그인',
    apple: 'Apple로 로그인',
    resetPassword: '비밀번호 재설정',
    resetDescription: '새 비밀번호를 설정할 수 있도록 로그인 링크를 보내드립니다.',
    sendResetLink: '재설정 링크 보내기',
    invalidToken: '토큰이 유효하지 않거나 만료되었습니다',
    enterEmail: 'e-mail을 입력하세요',
    resetSent: '계정이 존재하면 e-mail로 로그인 링크를 보냈습니다.',
    resetFailed: '재설정 링크를 보낼 수 없습니다. 다시 시도하세요.'
  },
  googleCallback: {
    wait: '잠시만 기다려 주세요. 로그인 중입니다...'
  },
  subscribe: {
    cloudRequiredTitle: '클라우드 스토리지 필요',
    cloudRequiredMessage: '이 기능은 클라우드 스토리지와 활성 구독이 있을 때만 사용할 수 있습니다.',
    title: '로컬로 시작하고 자동 업로드로 업그레이드하세요.',
    description: '클라우드는 여러 기기에서 동기화된 하나의 라이브러리를 제공합니다.',
    localFree: '앱은 로컬 모드에서 무료로 사용할 수 있습니다.',
    cloudIncludes: '클라우드 포함 사항',
    featureLibrary: '웹과 iPhone 간 동기화되는 하나의 라이브러리',
    featureAgent: '새 렌더링을 위한 데스크톱 에이전트 자동 업로드',
    featureStorage: '트랙용 100 GB 클라우드 스토리지',
    featureLinks: '트랙과 프로젝트용 영구 공개 링크',
    featureTools: '모든 로컬 분석, 효과, 내보내기 도구 포함',
    monthly: '월간',
    monthlyDescription: '클라우드 동기화, 언제든 취소 가능',
    yearly: '연간',
    yearlyDescription: '클라우드 동기화에 가장 좋은 가치',
    saveTen: '10% 절약',
    perMonth: '/월',
    billedMonthly: '매월 청구',
    billedYearly: '연 $53.89 청구',
    openingCheckout: '체크아웃 여는 중...',
    subscribePlan: '{plan} 구독',
    registerSubscribe: '가입하고 구독',
    securePayment: 'Polar를 통한 안전한 결제. 계정 설정에서 언제든 취소할 수 있습니다.',
    customPlan: '맞춤 플랜이 필요하거나 질문이 있나요? 문의:',
    privacy: '개인정보 처리방침',
    terms: '서비스 약관',
    refund: '환불 정책',
    checkoutFailed: '체크아웃을 생성할 수 없습니다. 다시 시도하세요.'
  },
  thanks: {
    title: '구독해 주셔서 감사합니다!',
    description: '이제 클라우드 스토리지를 사용할 수 있습니다. 구독 관리는 계정 페이지에서 확인하세요.',
    startWorking: '작업 시작',
    communities: '커뮤니티 참여',
    support: '문제가 있으면 {email} 또는 위 커뮤니티 링크로 문의하세요.'
  },
  help: {
    title: '도움말',
    intro: 'demoparty는 미완성 음악과 진행 중인 프로젝트를 위한 작업 공간입니다. 데모 저장, 효과 적용, 태그 편집, 기술 메타데이터 추적을 할 수 있습니다. 로컬 사용은 완전히 무료입니다.',
    uploadTitle: '업로드',
    uploadText: '메인 페이지의 Add 버튼을 클릭하여 트랙을 추가할 수 있습니다. 업로드 중 시스템이 키, BPM, LUFS를 자동으로 감지합니다. 업로드가 완료되면 확인 알림을 받습니다.',
    storageTitle: '스토리지',
    storageText: 'demoparty는 로컬과 클라우드 두 가지 스토리지 옵션을 제공합니다.',
    localStorageText: '로컬 스토리지는 모든 데이터를 기기에만 저장합니다. 트랙과 프로젝트는 업로드한 브라우저에서만 사용할 수 있습니다. 저장에는 IndexedDB가 사용됩니다. 등록이 필요 없으며 데이터가 어디에도 전송되지 않습니다.',
    cloudStorageText: '클라우드 스토리지는 데이터를 demoparty 서버에 저장합니다. 어디서든 언제든 트랙에 접근할 수 있습니다. 등록과 활성 구독이 필요합니다.',
    agentsTitle: '에이전트',
    agentsText: '클라우드 스토리지를 사용할 때 데스크톱 에이전트를 설치할 수 있습니다. 에이전트는 새로 렌더링된 트랙을 클라우드에 자동 업로드합니다.',
    publicLinksTitle: '공개 링크',
    publicLinksText: '클라우드 사용자는 트랙과 프로젝트에 대한 공개 링크를 만들 수 있습니다. 프로젝트 페이지에서 링크 버튼을 클릭하세요. 트랙의 경우 트랙 드롭다운 메뉴의 같은 아이콘을 사용하세요. 생성된 모든 링크는 설정에서 관리할 수 있습니다.',
    exportTitle: '내보내기',
    exportText: '트랙은 적용된 모든 효과와 함께 내보낼 수 있습니다. 트랙 페이지를 열고 내보내기를 선택하세요. 원본 파일을 다운로드하거나 MP3 또는 WAV로 내보낼 수 있습니다.',
    supportTitle: '지원',
    supportText: "demoparty 클라우드 구독 관련 문제는 support{'@'}demoparty.app 으로 문의하세요.",
    attributionsTitle: '저작권 표시',
    attributionsText: '다음 라이브러리들이 이 프로젝트를 가능하게 했습니다. 각 개발자에게 감사를 전합니다.'
  },
  cover: {
    upload: '커버 업로드',
    change: '커버 변경',
    delete: '커버 삭제',
    loading: '로딩 중...',
    selectImage: '이미지 파일을 선택하세요',
    uploadError: '커버 이미지 업로드 오류'
  }
}
